import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getTintControlData, seTintControlData, clearTintState, setCurrentWindowTintPage, setCurrentZoneStep, setSelectedTintLevel, setSelectedWindows, setWindowTint } from '../../../../../action/roomControlAction'
import { closeOrderPopUp } from '../../../../action/hCommerce2';
import { setLoader } from '../../../../action/homeAction'
import view_logo from '../assets/view_sw_logo.png'
import icon1 from '../assets/tint/ico_tint_clear_sel.svg'
import icon2 from '../assets/tint/ico_tint_light_sel.svg'
import icon3 from '../assets/tint/ico_tint_mid_sel.svg'
import icon4 from '../assets/tint/ico_tint_max_sel.svg'

function WindowZonesStep1(props) {


  const TintLevelImage = {
    1: icon1,
    2: icon2,
    3: icon3,
    4: icon4,
  }

  const handleClick = window => {
    let selectedWindows = props.selectedWindows.slice()
    if(selectedWindows.includes(window.tintCode)){
      selectedWindows.splice(selectedWindows.indexOf(window.tintCode), 1);
    } else {
      selectedWindows.push(window.tintCode)
    }
    props.setSelectedWindows(selectedWindows)
  }

  const cancelTint = () => {
    props.setLoader(true, "Sending request...")
    let count = 0;

    props.selectedWindows.forEach((identifier) => {
        props.setWindowTint(props.guestDetail, "cancelTintState" , identifier , "" , "", "" ,
        (status) => {
            count++;
            console.log("props.selectedWindows.length == count", status, props.selectedWindows.length, count);

            let tintData = {...props.tintControlData}
            let tintZone = tintData.zone
            if(status){
              tintZone.forEach((iterator,i) => {
                if(iterator.tintCode == identifier){
                  iterator.previousState = iterator.currentState;
                  iterator.currentState = null;
                  iterator.overrideLength = 0;
                  iterator.overrideSetAt = null;
                  iterator.overrideTimeLeft = 0;
                }
              })
            }

            if(props.selectedWindows.length == count){
                if(!status){
                    props.closeOrderPopUp(true, "Something went wrong. Please Contact Hotel admin. OR Try again after some time", "",true);
                    return
                }else{
                    props.closeOrderPopUp(true, `Tint Override has been set to default`, "",false);
                    props.setLoader(false, "")
                    props.setCurrentWindowTintPage("")
                    props.setSelectedWindows([])
                    props.setSelectedTintLevel(1)
                    props.seTintControlData(tintData)
                    props.setCurrentZoneStep(1)
                    // props.getTintControlData(props.guestDetail, (stat) => {
                    //   if(stat){
                    //   }
                    // })
                }
                
            }
        })
    })
}

    const overideAll = () => {
      let selectedWindows = props.selectedWindows.slice()
      props.windows.forEach((window) => {
        if (!selectedWindows.includes(window.tintCode)) {
          selectedWindows.push(window.tintCode)
        }
      })
      props.setSelectedWindows(selectedWindows)
    }

    const clearAll = () => {
      props.setSelectedWindows([])
    }

  return (
    <>
    <header class="inner-pages subpages w-footer">
        <a onClick={() => {props.goBack();props.setSelectedWindows([])}} class="button-back"></a>
        <div class="heading align-center">
          <p class="bold">Override</p>
        </div>
      </header>
      <section id="customizeRoom" class="widgets padding-bottom-2 margin-0">
        <div class="widgets">
          <div class="row">
            <div class="col">
              <p class="heading">Select Zones</p>
            </div>
          </div>
          <div class="row">
            <div class="col col-2 menu-items">
              {props.windows.map(window => <a key={window.tintCode} onClick={() => {handleClick(window)}} class={`tile-sm thumbnails tile-container no-img-ico ${props.selectedWindows.includes(window.tintCode) && "selected"}`}>
                { TintLevelImage.hasOwnProperty(window.currentState) && <span class="status-icon"><img src={ TintLevelImage[window.currentState]} /></span>}
                <div class="thumb-text align-center">
                  <p class="thumb-heading">{window.tintLabel}</p>
                </div>
              </a>)}
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p class="desc align-center">You can select multiple zones.</p>
              <img src={view_logo} class="ctl-logo" />
            </div>
          </div>
        </div>
      </section>

      {(props.selectedWindows.length <= 0) ?
      <footer class="button-controls">
        <section class="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
        <button class="primary w-100 all-caps" onClick={overideAll}>Overide All</button>
        </section>
      </footer>
      : (props.selectedWindows.length == props.windows.length) ?
      <footer class="button-controls">
        <section class="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
          <button class="primary w-100 all-caps margin-bottom-1" onClick={props.goNext}>Next</button>
          <button class="secondary w-100 all-caps margin-bottom-1" onClick={clearAll}>Clear All</button>
          <button class="secondary w-100 all-caps" onClick={cancelTint}>Cancel Override</button>
        </section>
      </footer>
      :
      <footer class="button-controls">
        <section class="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
          <button class="primary w-100 all-caps margin-bottom-1" onClick={props.goNext}>Next</button>
          <button class="secondary w-100 all-caps margin-bottom-1" onClick={overideAll}>Overide All</button>
          <button class="secondary w-100 all-caps" onClick={cancelTint}>Cancel Override</button>
        </section>
      </footer>
      }
      </>
  )
}

const mapStateToProps = state => {
  return {
    tintControlData: state.store.TintControlData,
    selectedWindows: state.store.selectedWindows,
    windows: state.store.TintControlData.zone,
    guestDetail: state.store.home.guestDetails,
    selectedTintLevel: state.store.selectedTintLevel
  }
}
export default connect(mapStateToProps, {setSelectedTintLevel, getTintControlData, seTintControlData ,closeOrderPopUp, setWindowTint, setLoader, clearTintState, setCurrentWindowTintPage, setSelectedWindows, setCurrentZoneStep})(WindowZonesStep1)